/**
 * Key-existence checks that also consult the default locale, so a key defined
 * only in the source locale still counts as translated in every other locale.
 */
export function useTranslationLookup() {
    const { te, defaultLocale } = useI18n();

    function hasTranslation(key: string): boolean {
        return te(key) || te(key, defaultLocale);
    }

    return { hasTranslation };
}
